
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    options: Array,
  },
})
export default class FilterTabs extends Vue {
  active = 0;

  handleClick(option: number) {
    this.active = option;
    this.$emit("handleClick", option);
  }
}
